var map = {
	"./module/aviso.module": [
		"./src/app/module/aviso.module.ts",
		"default~module-aviso-module~module-indicadores-module~module-investigacao-module~module-notificacao-~d524054d",
		"default~module-aviso-module~module-gerir-module~module-notificacao-module~module-unidade-saude-modul~528b52d0",
		"common",
		"module-aviso-module"
	],
	"./module/equipamento.module": [
		"./src/app/module/equipamento.module.ts",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~98fd5c94",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~87aa196b",
		"common",
		"module-equipamento-module"
	],
	"./module/export.module": [
		"./src/app/module/export.module.ts",
		"module-export-module"
	],
	"./module/gerir.module": [
		"./src/app/module/gerir.module.ts",
		"default~module-aviso-module~module-gerir-module~module-notificacao-module~module-unidade-saude-modul~528b52d0",
		"common",
		"module-gerir-module"
	],
	"./module/home-default.module": [
		"./src/app/module/home-default.module.ts",
		"module-home-default-module"
	],
	"./module/indicadores.module": [
		"./src/app/module/indicadores.module.ts",
		"default~module-aviso-module~module-indicadores-module~module-investigacao-module~module-notificacao-~d524054d",
		"common",
		"module-indicadores-module"
	],
	"./module/investigacao.module": [
		"./src/app/module/investigacao.module.ts",
		"default~module-aviso-module~module-indicadores-module~module-investigacao-module~module-notificacao-~d524054d",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~98fd5c94",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~87aa196b",
		"common",
		"module-investigacao-module"
	],
	"./module/material-medico-hospitalar.module": [
		"./src/app/module/material-medico-hospitalar.module.ts",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~98fd5c94",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~87aa196b",
		"common",
		"module-material-medico-hospitalar-module"
	],
	"./module/notificacao.module": [
		"./src/app/module/notificacao.module.ts",
		"default~module-aviso-module~module-indicadores-module~module-investigacao-module~module-notificacao-~d524054d",
		"default~module-aviso-module~module-gerir-module~module-notificacao-module~module-unidade-saude-modul~528b52d0",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~98fd5c94",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~87aa196b",
		"common",
		"module-notificacao-module"
	],
	"./module/perfil.module": [
		"./src/app/module/perfil.module.ts",
		"module-perfil-module"
	],
	"./module/regioes.module": [
		"./src/app/module/regioes.module.ts",
		"common",
		"module-regioes-module"
	],
	"./module/setores.module": [
		"./src/app/module/setores.module.ts",
		"default~module-equipamento-module~module-investigacao-module~module-material-medico-hospitalar-modul~98fd5c94",
		"common",
		"module-setores-module"
	],
	"./module/tags.module": [
		"./src/app/module/tags.module.ts",
		"default~module-aviso-module~module-indicadores-module~module-investigacao-module~module-notificacao-~d524054d",
		"common",
		"module-tags-module"
	],
	"./module/unidade-saude.module": [
		"./src/app/module/unidade-saude.module.ts",
		"default~module-aviso-module~module-indicadores-module~module-investigacao-module~module-notificacao-~d524054d",
		"default~module-aviso-module~module-gerir-module~module-notificacao-module~module-unidade-saude-modul~528b52d0",
		"common",
		"module-unidade-saude-module"
	],
	"./module/usuarios.module": [
		"./src/app/module/usuarios.module.ts",
		"default~module-aviso-module~module-gerir-module~module-notificacao-module~module-unidade-saude-modul~528b52d0",
		"common",
		"module-usuarios-module"
	],
	"./module/vinculacao.module": [
		"./src/app/module/vinculacao.module.ts",
		"common",
		"module-vinculacao-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;